const FRAME_RESIZE_CORNER_SIZE = 32;
const FRAME_RESIZE_EDGE_INSET = 16;
const FRAME_RESIZE_EDGE_THICKNESS = 16;

export const RESIZE_LINES = ["top", "right", "bottom", "left"] as const;
export const RESIZE_CORNERS = [
  "top-left",
  "top-right",
  "bottom-left",
  "bottom-right",
] as const;

export type ResizePosition =
  | (typeof RESIZE_LINES)[number]
  | (typeof RESIZE_CORNERS)[number];

export function resizeCursor(position: ResizePosition) {
  switch (position) {
    case "top":
      return "cursor-n-resize";
    case "right":
      return "cursor-e-resize";
    case "bottom":
      return "cursor-s-resize";
    case "left":
      return "cursor-w-resize";
    case "top-left":
    case "bottom-right":
      return "cursor-nwse-resize";
    case "top-right":
    case "bottom-left":
      return "cursor-nesw-resize";
  }
}

export function resizeLineStyle(position: (typeof RESIZE_LINES)[number]) {
  if (position === "top" || position === "bottom") {
    return {
      left: FRAME_RESIZE_EDGE_INSET,
      right: FRAME_RESIZE_EDGE_INSET,
      width: `calc(100% - ${FRAME_RESIZE_EDGE_INSET * 2}px)`,
      height: FRAME_RESIZE_EDGE_THICKNESS,
    };
  }
  return {
    top: FRAME_RESIZE_EDGE_INSET,
    bottom: FRAME_RESIZE_EDGE_INSET,
    width: FRAME_RESIZE_EDGE_THICKNESS,
    height: `calc(100% - ${FRAME_RESIZE_EDGE_INSET * 2}px)`,
  };
}

export function resizeCornerStyle(_position: (typeof RESIZE_CORNERS)[number]) {
  return {
    width: FRAME_RESIZE_CORNER_SIZE,
    height: FRAME_RESIZE_CORNER_SIZE,
  };
}
